import React, { useState, useEffect } from 'react';

import Charsheet01 from './Charsheet01.js'

// ----------------------------------------------------------------------------------
//     (c) DXA Development 2023
// ----------------------------------------------------------------------------------

function Index(props) {

    // ---------- return html (jsx) ----------

    return (
        <Charsheet01 {...props} />
    )

    };  // end of function

    export default Index